module.exports = __webpack_public_path__ + "img/page2-bg-phone.2bbea25b.png";